import { themeGet } from '@styled-system/theme-get';
import { Flex, Box, Text, Icon, NakedButton } from '@qga/roo-ui/components';
import styled from '@emotion/styled';

const CloseText = styled(Text)`
  &:hover {
    color: ${themeGet('colors.brand.secondary')};
  }
`;

const CloseButton = ({ onClick, disableClose }) => (
  <NakedButton onClick={onClick} disabled={disableClose} aria-label="Close Dialog">
    <CloseText color="white" textStyle="text" fontWeight="bold" fontSize="lg">
      Close <Icon name="close" pl={1} size={26} />
    </CloseText>
  </NakedButton>
);

const ModalHeader = ({ title, onRequestClose, aria, disableClose }) => (
  <Flex bg="greys.steel" py={3} pl={7} pr={4} flex="0 0 auto" justifyContent="space-between" alignItems="baseline">
    <Box>
      {title && (
        <Text m={0} fontSize="lg" color="white" id={aria.labelledby}>
          {title}
        </Text>
      )}
    </Box>
    <Box>
      <CloseButton onClick={onRequestClose} disableClose={disableClose} />
    </Box>
  </Flex>
);

export default ModalHeader;
